// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick_signup_container_quick {
    max-width: 520px;
    margin: 3rem auto;
    padding: 2.5rem;
    border-radius: 16px;
    background: linear-gradient(to bottom right, var(--clr-grey-5), #ffffff);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease-in-out;
    border: 3px solid var(--clr-primary-3);
  }
  
  .quick_signup_title_quick {
    text-align: center;
    margin-bottom: 2rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--clr-primary-8);
  }
  
  .quick_signup_form_quick {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
  
  .form-row_quick {
    display: flex;
    flex-direction: column;
  }
  
  .form-label_quick {
    font-weight: 600;
    font-size: 0.95rem;
    margin-bottom: 0.3rem;
    color: var(--clr-grey-1);
    transition: color 0.2s;
  }
  
  .required_quick {
    color: red;
    margin-left: 0.25rem;
  }
  
  .form-input_quick {
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid var(--clr-grey-4);
    border-radius: 8px;
    background-color: #fff;
    transition: border 0.3s ease, box-shadow 0.3s ease;
  }
  
  .form-input_quick:focus {
    border-color: var(--clr-primary-5);
    box-shadow: 0 0 0 3px rgba(100, 100, 255, 0.1);
    outline: none;
  }
  
  .error-text_quick {
    color: red;
    font-size: 0.85rem;
    margin-top: 0.25rem;
  }
  
  .quick_signup_button_quick {
    padding: 0.85rem;
    background-color: var(--clr-primary-5);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 1.05rem;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .quick_signup_button_quick:hover {
    background-color: var(--clr-primary-6);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }
  
  .phone-input-container_quick {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
  
  .phone-prefix_quick {
    padding: 0.75rem;
    background-color: var(--clr-grey-3);
    border: 1px solid var(--clr-grey-4);
    border-radius: 8px;
    width: 3rem;
    text-align: center;
    font-weight: bold;
    color: var(--clr-grey-8);
  }
  
  .phone-main-input_quick {
    flex: 1 1;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/QuickPatientSignup/QuickPatientSignup.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,wEAAwE;IACxE,0CAA0C;IAC1C,gCAAgC;IAChC,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,sBAAsB;IACtB,kDAAkD;EACpD;;EAEA;IACE,kCAAkC;IAClC,8CAA8C;IAC9C,aAAa;EACf;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,yCAAyC;EAC3C;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mCAAmC;IACnC,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,SAAO;EACT","sourcesContent":[".quick_signup_container_quick {\n    max-width: 520px;\n    margin: 3rem auto;\n    padding: 2.5rem;\n    border-radius: 16px;\n    background: linear-gradient(to bottom right, var(--clr-grey-5), #ffffff);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n    transition: all 0.3s ease-in-out;\n    border: 3px solid var(--clr-primary-3);\n  }\n  \n  .quick_signup_title_quick {\n    text-align: center;\n    margin-bottom: 2rem;\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: var(--clr-primary-8);\n  }\n  \n  .quick_signup_form_quick {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n  \n  .form-row_quick {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .form-label_quick {\n    font-weight: 600;\n    font-size: 0.95rem;\n    margin-bottom: 0.3rem;\n    color: var(--clr-grey-1);\n    transition: color 0.2s;\n  }\n  \n  .required_quick {\n    color: red;\n    margin-left: 0.25rem;\n  }\n  \n  .form-input_quick {\n    padding: 0.75rem;\n    font-size: 1rem;\n    border: 1px solid var(--clr-grey-4);\n    border-radius: 8px;\n    background-color: #fff;\n    transition: border 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .form-input_quick:focus {\n    border-color: var(--clr-primary-5);\n    box-shadow: 0 0 0 3px rgba(100, 100, 255, 0.1);\n    outline: none;\n  }\n  \n  .error-text_quick {\n    color: red;\n    font-size: 0.85rem;\n    margin-top: 0.25rem;\n  }\n  \n  .quick_signup_button_quick {\n    padding: 0.85rem;\n    background-color: var(--clr-primary-5);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 1.05rem;\n    transition: all 0.3s ease-in-out;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .quick_signup_button_quick:hover {\n    background-color: var(--clr-primary-6);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n  }\n  \n  .phone-input-container_quick {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n  }\n  \n  .phone-prefix_quick {\n    padding: 0.75rem;\n    background-color: var(--clr-grey-3);\n    border: 1px solid var(--clr-grey-4);\n    border-radius: 8px;\n    width: 3rem;\n    text-align: center;\n    font-weight: bold;\n    color: var(--clr-grey-8);\n  }\n  \n  .phone-main-input_quick {\n    flex: 1;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
